import { Link } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import { ISSUER, ISSUED_YEAR } from '@/lib/book';

const CAREER = [
  '1935년생',
  '1969.3.5 뉴대전로타리클럽 창립회원',
  '1980-81 뉴대전로타리클럽 회장',
  '1989-90 국제로타리 3680지구 총재',
  '1998-2000 (사)한국로타리총재단 의장',
  '2006-07 한국로타리장학문화재단 제13대 이사장',
  '충남대병원 의료아너소사이어티 초대위원장',
];

const HONORS = [
  '1983 산업포장',
  '1996 국민훈장 동백장',
  '아치 클럼프 소사이어티 회원',
];

export default function About() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteHeader />

      <main>
        <section className="w-full bg-primary-900">
          <div className="mx-auto w-full px-4 py-14 md:px-10 md:py-20">
            <p className="font-label text-sm font-medium tracking-[0.25em] text-accent-300">소개</p>
            <h1 className="mt-4 font-heading text-3xl font-bold text-background-50 md:text-5xl">
              세창(世倉) 박종윤
            </h1>
            <p className="mt-4 max-w-3xl text-sm leading-relaxed text-primary-100 md:text-base">
              국제로타리 3680지구 1989-90 총재. 1969년 뉴대전로타리클럽 창립회원으로 첫 발을 디딘 뒤,
              반세기 동안 봉사의 자리를 지켜온 기록을 한 권의 사진 자서전으로 남겼습니다.
            </p>
          </div>
        </section>

        <section className="w-full bg-background-50">
          <div className="mx-auto grid w-full grid-cols-1 gap-10 px-4 py-14 md:px-10 md:py-20 lg:grid-cols-2 lg:gap-16">
            <div>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">약력</h2>
              <p className="mt-3 text-sm leading-relaxed text-secondary-600">
                봉사와 기업, 그리고 지역을 향한 반세기의 발자취입니다.
              </p>
              <ol className="mt-8 space-y-5">
                {CAREER.map((item) => (
                  <li key={item} className="flex gap-4">
                    <span className="mt-2 flex h-2.5 w-2.5 shrink-0 items-center justify-center rounded-full bg-accent-500" aria-hidden="true"></span>
                    <span className="text-base leading-relaxed text-foreground-800">{item}</span>
                  </li>
                ))}
              </ol>
            </div>

            <div>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">상훈</h2>
              <p className="mt-3 text-sm leading-relaxed text-secondary-600">
                봉사의 시간이 남긴 훈장과 명예입니다.
              </p>
              <ul className="mt-8 space-y-4">
                {HONORS.map((item) => (
                  <li
                    key={item}
                    className="flex items-center gap-3 rounded-lg border border-background-300 bg-background-100 px-5 py-4"
                  >
                    <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                      <i className="ri-award-line text-lg" aria-hidden="true"></i>
                    </span>
                    <span className="text-base text-foreground-800">{item}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-8 rounded-lg border border-background-300 bg-background-100 px-5 py-5">
                <p className="font-label text-sm font-medium text-accent-700">발행</p>
                <p className="mt-2 font-heading text-lg font-bold text-foreground-950">
                  {ISSUER}, {ISSUED_YEAR}
                </p>
                <p className="mt-2 text-sm leading-relaxed text-secondary-600">
                  국제로타리 3680지구 · 뉴대전로타리클럽
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full bg-background-100">
          <div className="mx-auto flex w-full flex-col items-start gap-5 px-4 py-12 md:flex-row md:items-center md:justify-between md:px-10 md:py-14">
            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                지금 바로 책을 펼쳐 보세요
              </h2>
              <p className="mt-2 text-sm text-secondary-600 md:text-base">
                표지부터 148쪽까지, 실제 책장을 넘기듯 한 장씩 볼 수 있습니다.
              </p>
            </div>
            <Link
              to="/read?page=1"
              className="inline-flex min-h-[48px] shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 font-label text-base font-bold text-primary-950 transition-colors hover:bg-accent-400"
            >
              <i className="ri-book-open-line text-lg" aria-hidden="true"></i>
              책 읽기 시작
            </Link>
          </div>
        </section>
      </main>

      <SiteFooter />
    </div>
  );
}